import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer>
            <p>© 2026 by ABM Property Management | <Link to="/Terms" target="_blank">Terms Of Use</Link> | <Link to="/Privacy" target="_blank">Privacy Statement</Link></p>
        </footer>
    )
}
export default Footer;